var _defs, _path, _circle;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDashIconRedAlert(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 60.4 60.4",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n            .prefix__cls-2{fill:#fff}\n        "))), /*#__PURE__*/React.createElement("g", {
    id: "prefix__Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "prefix__Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30.2 0a30.2 30.2 0 1 0 30.2 30.2A30.22 30.22 0 0 0 30.2 0z",
    style: {
      fill: "#d81a1a"
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.18 15.1a4 4 0 0 1 4-4 4 4 0 0 1 4 4v16.17a4 4 0 0 1-4 4 4 4 0 0 1-4-4z",
    className: "prefix__cls-2"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 30.2,
    cy: 44.48,
    r: 4.92,
    className: "prefix__cls-2"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashIconRedAlert);
export default __webpack_public_path__ + "static/media/dash-icon-red-alert.aa90e2d989f28cc2127f778becbe84f8.svg";
export { ForwardRef as ReactComponent };